import { gsap } from 'gsap';

export default class Header {
  constructor() {
    // this.menuOpen = false;
    this.currentY = 0;
    this.navFlag = false;
    this.hamburger = document.querySelector('.js-gnav-trigger');
    // this.navMenu = document.querySelector('.nav-menu');
    this.hamburger.addEventListener('click', this.toggleMenu.bind(this));
    this.body = document.querySelector('body');
    this.flowNav = document.querySelector('.header-flow-nav');
    this.init();
  }

  init() {


    this.navHasSubs = [...document.querySelectorAll('[data-subnav-has]')];
    this.navsubs = [...document.querySelectorAll('[data-subnav]')];

    [...this.navHasSubs, ...this.navsubs].forEach(item => {
      item.addEventListener('mouseover', this.navsubMouseover.bind(this));
      item.addEventListener('mouseleave', this.navsubMouseleave.bind(this));
      // item.addEventListener('focus', this.navsubMouseover.bind(this));
      // item.addEventListener('blur', this.navsubMouseleave.bind(this));
    });

  }

  toggleMenu() {
    // this.hamburger.classList.toggle('active');
    // this.body.classList.toggle('is_toggle-open');

    // if (this.hamburger.classList.contains('active')) {
    //   this.currentY = window.scrollY;
    //   this.body.style.overflow = 'hidden';
    // } else {
    //   window.scrollTo(0, this.currentY);
    //   this.body.style.overflow = '';
    // }

    if (!this.navFlag) {
      this.currentY = window.scrollY || window.pageYOffset
      this.navFlag = true;
      this.hamburger.classList.add('is-active');
      this.body.classList.add('is_toggle-open');
    } else {
      this.hamburger.classList.remove('is-active');
      this.body.classList.remove('is_toggle-open');
      this.navFlag = false;
      window.scrollTo(0, this.currentY);
    }
  }

    //mouseover
    navsubMouseover(e) {
      let ctarget = e.currentTarget;
      let btns = this.getElement(ctarget, 'btn');
      let nav = this.getElement(ctarget);
      ctarget.classList.add('is-active');
      nav.classList.add('is-active');
      this.flowNav.style.display = 'none';

      if (ctarget.dataset.subnav) {
        btns.classList.add('is-active');
      }
      gsap.killTweensOf(nav);
      gsap.to(nav, {
        duration: 0.0,
        autoAlpha: 1,
        // delay:.1,
        ease: "power4.out",
        // y:0,
        // zIndex: -1,
      });
    }
    navsubMouseleave(e) {
      let ctarget = e.currentTarget;
      let btns = this.getElement(ctarget, 'btn');
      let nav = this.getElement(ctarget);
      this.flowNav.style.display = 'block';
      // this.headerBg.classList.remove('active');
      gsap.killTweensOf(nav);
      btns.classList.remove('is-active');
      nav.classList.remove('is-active');
      gsap.to(nav, {
        duration: .0,
        autoAlpha: 0,
        ease: "power4.out",
        // delay:.1,
        // y:-10,
        // y:'-100%',
        onComplete:() => {
          // if(!ctarget.dataset.subnavHas) {
          //   btns.classList.remove('active');
          // }
          // btns.classList.remove('is-active');
          // if (ctarget.dataset.subnav) {
          //   console.log(ctarget);
          //   btns.classList.add('active');
          // }
          // btns.classList.remove('active');
          // nav.classList.remove('active');
          // nav.classList.remove('active');
        }
      })
    }


  getElement(target, type = null) {
    let closestHeader = target.closest(".header");
    let cat = target.getAttribute('data-subnav-has')||target.getAttribute('data-subnav');
    switch (type) {
      case 'btn':
        var ele = closestHeader.querySelector(`[data-subnav-has="${cat}"]`);
        break;
      default:
        var ele = closestHeader.querySelector(`[data-subnav="${cat}"]`);
        break;
    }
    return ele;
  }

}

